<!--
 * @Descripttion: 
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-02-14 23:36:16
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-04-13 22:52:17
-->
<template>
  <edu-layout type="table">
    <hqStuPositionApply viewType="shen" slot="table"></hqStuPositionApply>
  </edu-layout>
</template>

<script>
import hqStuPositionApply from './base/hqStuPositionApply';
export default {
  components: {
    hqStuPositionApply
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less" scoped></style>
